// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const enterpriseRolesClient = createTypedClient();
export const createEnterpriseRolesClient = (config) => createTypedClient(config);
